import React from 'react';
import Spinner from '../interface/spinner';

const Button = props => {
  const {
    className,
    disabled,
    onClick,
    labelLocale,
    id,
    loading,
    title
  } = props;
  
  const dataEntityData = props["data-entitydata"];
  const dataAction = props["data-action"];
  return (
    <button
      className={"matter-button-contained" + (className ? " " + className : "")}
      disabled={disabled}
      onClick={onClick}
      data-entitydata={dataEntityData}
      data-action={dataAction}
      id={id}
      title={title}
    >
      {labelLocale}
      {loading && (<Spinner/>)}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/button.jsx